import { Helmet } from 'react-helmet-async';
import classes from 'classnames';
import { Button, HelpInfo, Typography } from 'components';
import { isNowHoliday } from 'utils';
import { useTranslation } from 'react-i18next';
import styles from 'pages/Registration/BankId/BankError/BankIdError.module.scss';
import useBankIdError from 'pages/Registration/BankId/BankError/useBankIdError';

function BankIdError() {
  const { t } = useTranslation();
  const { translation, statusFromRoute, handleSkip } = useBankIdError();

  return (
    <div
      className={classes(
        styles.wrapper,
        statusFromRoute && styles['full-width'],
      )}
      data-test="bank-id-error"
    >
      <Helmet>
        <title>{translation.title}</title>
      </Helmet>
      <Typography
        kind="h1"
        size="xl"
        color="primary"
        className={styles.textCenter}
      >
        {translation.title}
      </Typography>
      <Typography
        size="s"
        className={classes(styles.description, styles.textCenter)}
      >
        {translation.description}
      </Typography>

      <Button onClick={handleSkip} className={styles.button}>
        {translation.button}
      </Button>

      <div className={styles['help-info']}>
        <HelpInfo
          title={t('help_info:title')}
          text={
            isNowHoliday()
              ? t('help_info:contact_details_holiday')
              : t('help_info:contact_details')
          }
        />
      </div>
    </div>
  );
}

export default BankIdError;
